import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import ToolLayout from 'tools/ToolLayout';
import SelectCard from 'components/SelectCard';
import Colors from 'theme/colors';
import { TOOLS } from 'tools/toolsCatalog';

const intro: any = {
  backgroundColor: Colors.WHITE,
  border: `1px solid ${Colors.CARD_BORDER}`,
  borderRadius: 12,
  padding: '16px 18px',
  marginBottom: 16,
};

const introTitle: any = {
  margin: '0 0 6px',
  fontSize: 20,
  fontWeight: 700,
  color: Colors.MAIN_COLOR,
};

const introText: any = {
  margin: 0,
  fontSize: 14,
  lineHeight: '22px',
  color: Colors.MUTED_TEXT,
};

const section: any = {
  margin: '8px 8px 4px',
  fontSize: 15,
  fontWeight: 700,
  color: Colors.TEXT,
};

/** Full document navigation so COOP/COEP headers apply (FFmpeg SharedArrayBuffer). */
const FULL_RELOAD_PATHS: { [key: string]: boolean } = {
  '/tools/video-logo': true,
  '/tools/convert-audio': true,
  '/tools/convert-video': true,
  '/tools/text-to-speech': true,
  '/tools/dictation': true,
};

const ToolsHome: FC = () => {
  const history = useHistory();
  const g: any = typeof global !== 'undefined' ? global : {};
  const win = g.window || g;

  const openTool = (path: string) => {
    if (FULL_RELOAD_PATHS[path] && win && win.location) {
      win.location.assign(path);
      return;
    }
    history.push(path);
  };

  return (
    <ToolLayout title="Công cụ Language123" showBackToTools={false}>
      <div style={intro}>
        <h2 style={introTitle}>Tiện ích độc lập</h2>
        <p style={introText}>
          Các công cụ nhỏ dùng trực tiếp trên trình duyệt — không liên quan tới bài ôn TOEIC.
          Chọn một công cụ bên dưới để bắt đầu.
        </p>
      </div>

      <div style={section}>Danh sách công cụ</div>
      {TOOLS.map((tool) => (
        <SelectCard
          key={tool.id}
          title={tool.title}
          subtitle={tool.subtitle}
          meta={tool.meta}
          badge={tool.badge}
          onPress={() => openTool(tool.path)}
        />
      ))}
    </ToolLayout>
  );
};

export default ToolsHome;
